import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  DeliveryConfigurationData,
  DeliveryDetails,
  DeliveryHistory,
  DeliveryProviderPrice,
  EstimatedDeliveryTimeElement,
  OrderCalculation,
} from "../entities/delivery.entities";
import { DeliverySourceType } from "../entities/delivery.entities";
import { initialDeliveryState } from "./delivery.state";

const deliverySlice = createSlice({
  name: "delivery",
  initialState: initialDeliveryState,
  reducers: {
    reset: () => initialDeliveryState,
    setHistory: (state, action: PayloadAction<DeliveryHistory | null>) => {
      state.history = action.payload;
    },
    setHistoryLoading: (state, action: PayloadAction<boolean>) => {
      state.historyLoading = action.payload;
    },
    setHistoryError: (state, action: PayloadAction<string | null>) => {
      state.historyError = action.payload;
    },
    setSourceType: (state, action: PayloadAction<DeliverySourceType>) => {
      state.sourceType = action.payload;
    },
    setLinkedOrderId: (state, action: PayloadAction<number | null>) => {
      state.linkedOrderId = action.payload;
    },
    setCalculation: (state, action: PayloadAction<OrderCalculation | null>) => {
      state.calculation = action.payload;
    },
    setProviders: (state, action: PayloadAction<DeliveryProviderPrice[]>) => {
      state.providers = action.payload;
    },
    setProvidersLoading: (state, action: PayloadAction<boolean>) => {
      state.providersLoading = action.payload;
    },
    setSelectedProvider: (
      state,
      action: PayloadAction<DeliveryProviderPrice | null>
    ) => {
      state.selectedProvider = action.payload;
    },
    setDeliveryConfigData: (
      state,
      action: PayloadAction<DeliveryConfigurationData | null>
    ) => {
      state.deliveryConfigData = action.payload;
    },
    setEstimatedTimes: (
      state,
      action: PayloadAction<EstimatedDeliveryTimeElement[]>
    ) => {
      state.estimatedTimes = action.payload;
    },
    setCurrentDetail: (state, action: PayloadAction<DeliveryDetails | null>) => {
      state.currentDetail = action.payload;
    },
    setCheckoutLoading: (state, action: PayloadAction<boolean>) => {
      state.checkoutLoading = action.payload;
    },
    setCheckoutError: (state, action: PayloadAction<string | null>) => {
      state.checkoutError = action.payload;
    },
  },
});

export const deliveryActions = deliverySlice.actions;
export const deliveryReducer = deliverySlice.reducer;
